<template>
  <div class="option-panel-group" v-if="data && data.length" v-loading="loading">

    <div class="option-panel-group-box flex">
      <gj-card
          tabCard
          :padding="'19px 0 19px 16px'"
          :title="getTitle(item)"
          :number="getNum(item)"
          :numberColor="isMeaningful(helpList[item.label])?numberColor:null"
          @click="selectChart(index)"
          :active="currentSelect.key === item.key"
          v-for="(item, index) in data" :key="index"
      >
        <template #title v-if="isMeaningful(helpList[item.label])&&helpList[item.label].length>0&&showHelp">
          <gj-help :left="'4px'" :list="helpList[item.label]">
          </gj-help>
        </template>
        <template #info>
          <div class="total-panel--title">
            <span class="total-panel--day-label">{{'环比    :'}}</span>
            <ChainRatio :itemKey="item.key" :isBlock="true" :percent="parseInt(item.percent)"/>
          </div>
        </template>
      </gj-card>

      <div class="add-card flex justify-center align-center" @click="openSetting" v-if="data.length < 8">
        <i class="el-icon-plus op-icon"></i>
      </div>

    </div>
  </div>
</template>

<script>
import ChainRatio from "@/views/components/chain-ratio/chain-ratio"
import { amountSymbol } from "@/filters"
import {isMeaningful, isMeaningless} from "@/utils/common";
export default {
  name: "option-panel-group",
  components:  {ChainRatio},
  props: {
    currentSelect: {
      type: Object,
      default() {
        return {}
      }
    },
    data: Array,
    loading:{
      type: Boolean,
      default: false
    },
    //是否显示问号
    showHelp:{
      type: Boolean,
      default: false
    },
    numberColor:null
  },
  data(){
    return {
      helpList:{
        Sessions:[
          '数据来源：亚马逊业务报告',
          '字段：sessions',
          '说明：按国家店铺查找时，使用按日期流量数据；按品类、运营状态查找时，使用按商品MSKU流量数据'
        ],
        CVR:[
          '数据来源：亚马逊业务报告',
          '字段：销量/sessions',
          '说明：按国家店铺查找时，使用按日期流量数据；按品类、运营状态查找时，使用按商品MSKU流量数据'
        ],
        PV:[],
        Buybox:[]
      }
    }
  },
  methods: {
    isMeaningful,
    getTitle(item){
      let str='-';
      if(item.label){
        str = item.label
      }
      if(item.prefix === 'currencySymbol'&&item.currencySymbol){
        str+='('+item.currencySymbol+')'
      }
      return str
    },
    getNum(item){
      if(isMeaningless(item.value)){
        return '-'
      }
      if(item.prefix === 'currencySymbol'){
        return amountSymbol(item.value || 0,2)
      }else {
        return (item.value || 0) + (item.suffix || '')
      }
    },
    selectChart(index) {
      this.$emit('update:currentSelect', this.data[index])
    },
    /**
     * 打开设置
     */
    openSetting(){
      this.$emit("openSetting");
    }
  },
  watch: {
    data (val) {
      if (val && val.length) {
        this.selectChart(0)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.option-panel-group{
  margin-bottom: 10px;
}
.gj-card{
  margin-right: -1px;
  &:hover{
    z-index: 10;
  }
}
.gj-card.active{
  z-index: 10;
}
.gj-card:first-child{
  border-radius: 2px 0 0 2px;
}
.gj-card:last-child{
  border-right: 1px solid #D8DADD;
  border-radius: 0 2px 2px 0;
}

.total-panel {
  .total-panel--5:nth-of-type(1) &--report &--title &--title__tag {
    background: #FC6B6B;
  }

  .total-panel--5:nth-of-type(2) &--report &--title &--title__tag {
    background: #F1AF2A;
  }

  .total-panel--5:nth-of-type(3) &--report &--title &--title__tag {
    background: #79F12A;
  }

  .total-panel--5:nth-of-type(4) &--report &--title &--title__tag {
    background: #2AF1C2;
  }

  .total-panel--5:nth-of-type(5) &--report &--title &--title__tag {
    background: #F50B0B;
  }

  .total-panel--5:nth-of-type(6) &--report &--title &--title__tag {
    background: #2A4BF1;
  }

  .total-panel--5:nth-of-type(7) &--report &--title &--title__tag {
    background: #A92AF1;
  }

  .total-panel--5:nth-of-type(8) &--report &--title &--title__tag {
    background: #F12ADD;
  }
}

.total-panel--5 {
  width: 12.5%;
  box-sizing: border-box;
}
.add-card{
  height: 128px;
  width: 12.5%;
  color: #D8DADD;
  font-weight: bold;
  background-color: #f6f8fb;
  transition: color .2s;
  .op-icon{
    font-size: 30px;
    font-weight: bold;
  }
  &:hover{
    color: #1F6EEF;
  }
}
.add-panel{
  min-height: 98px;
  text-align: center !important;
  line-height: 98px;
  color: #1F6EEF;
  font-weight: bold;

  .op-icon{
    font-size: 30px;
    font-weight: bold;
  }
}

.total-panel--content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 8px 0;
  background: #FAFAFA;
  border-radius: 4px;
}

.total-panel--title {
  color: #999999;
  display: flex;
  align-items: center;
  //justify-content: space-between;

  &:nth-of-type(1) div {
    background: red;
  }

  &:nth-of-type(2) div {
    background: yellow;
  }


  &__tag {
    display: inline-block;
    width: 6px;
    height: 13px;
    border-radius: 3px;
    margin-left: 5px;
   }
}

.total-panel--summary {
  margin-bottom: 17px;
  font-size: 18px;
  line-height: 24px;
  //font-weight: bold;
}

.total-panel--title:last-child {
  margin-bottom: 0;

}
.total-panel--report {
  cursor: pointer;
  text-align: left;
  border: 1px solid #D8DADD;
  border-radius: 4px;
  padding: 10px;
  //min-width: 136px;
  //min-height: 116px;
}
.total-panel--day-number {
  font-size: 12px;
}
.total-panel--day-label {
  font-size: 12px;
  margin-right: 41px;
}

.total-panel--report:hover {
  border-color: #1F6EEF;
}

.total-panel--report.active {
  border-color: #1F6EEF;
}
.down-icon,.el-icon-bottom  {
  color: #F56C6C;
}
.up-icon,.el-icon-top {
  color: #19BE6B;
}
.option-panel-group-box{
  justify-content: space-between;
  /deep/ .gj-card{
    flex: 1;
  }
}
</style>
